var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { PromptTemplateSelect } from '../entities/prompt-template-select';
import { PromptTemplateForm } from '../entities/prompt-template-form';
import { useGpt } from '../hooks/use-gpt';
var cls = classNames('gpt-prompt');
export var GptPromptDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    border-top: 1px solid ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    border-top: 1px solid ", ";\n  "])), theme.COLOR('line-semi-subtle'))
});
var TemplateSelectStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-shrink: 0;\n    width: calc(100% - 5px);\n  "], ["\n    flex-shrink: 0;\n    width: calc(100% - 5px);\n  "])))
});
var FormStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n  "], ["\n    padding: ", " 0 ", ";\n  "])), theme.UNIT(4), theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TemplateSelect: styled(PromptTemplateSelect)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TemplateSelectStyles),
  FormContainer: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  Form: styled(PromptTemplateForm)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), FormStyles)
};
export var GptPrompt = function (props) {
  var className = props.className,
    entity = props.entity;
  var entityGpt = useGpt({
    entity: entity
  });
  var onChange = function (entity) {
    entityGpt.selectTemplate({
      entity: entity
    });
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.TemplateSelect, {
    value: entityGpt.activeTemplate,
    onChange: onChange
  }), entityGpt.activeTemplate && React.createElement(My.Form, {
    entity: entity
  }));
};
GptPrompt.cls = cls;
GptPrompt.defaultProps = GptPromptDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;